import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";
/**
 * Get list of subsidiaries (filiales)
 */
export async function getStateLocations() {
  try {
    // Search data
    const response = await fetch(BASE_URL + "insurance/state/", {
      headers: {
        ...getAuthHeader(),
      }
    });
    if (!response.ok) {
      throw new Error("Error fetching subsidiaries");
    }

    const data = await response.json();
    /**@type {Subsidiary[]} */
    const results = data;
    return results;
  } catch (error) {
    console.error("Error fetching subsidiaries", error);
    return [];
  }
}